import { render, staticRenderFns } from "./StudyAnswerHorizontal.vue?vue&type=template&id=4e5e0020&scoped=true&lang=pug"
import script from "./StudyAnswerHorizontal.vue?vue&type=script&lang=ts"
export * from "./StudyAnswerHorizontal.vue?vue&type=script&lang=ts"
import style0 from "./StudyAnswerHorizontal.vue?vue&type=style&index=0&id=4e5e0020&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5e0020",
  null
  
)

export default component.exports